import ImageGatsbyCDAContainer from './ImageGatsbyCDAContainer.js'
import ImageApolloCPAContainer from './ImageApolloCPAContainer.js'
export default ImageGatsbyCDAContainer
export { ImageGatsbyCDAContainer, ImageApolloCPAContainer }
